import { ref } from 'vue';

const getFavourites = () => {
    const favourites_error = ref(null);
    const favourites = ref(null);

    const loadFavourites = async () => {
      try {

        let data = await fetch("/api/experienceprojects?favourites=true");

        if (!data.ok) {
          throw Error("Can't load data");
        }

        favourites.value = await data.json();

        //console.log('projects', projects.value);
      } catch (err) {
        favourites_error.value = err.message;
      }
    };

    return { favourites, favourites_error, loadFavourites};
}

export default getFavourites;
